module.exports = __webpack_public_path__ + "img/21-plus.000456f5.png";